const getMetaData = [
  'Private.Toyota.Ignition.Status',
  'Private.Toyota.resolution.height',
  'Private.Toyota.resolution.wide',
  'Private.Toyota.Com.Setting.Wifi.Tethering',
  'Private.Toyota.VehicleInfo.HUSystem.DriversDistraction',
  'Private.Toyota.VehicleInfo.HUSystem.DayNight',
  'Private.Toyota.VehicleInfo.VehicleState.Gear',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.HUGrade',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.HUSW',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.HUProfile',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.HUSupplier',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.HUIdentifier',
  'Private.Toyota.Attribute.Vehicle.VehicleIdentification.VIN.data',
  'Signal.OBD.HybridBatteryRemaining',
  'Signal.Drivetrain.Transmission.Speed',
  'Signal.Drivetrain.FuelSystem.Range',
];

export default {
  getMetaData,
};
